// 261005 E1-P2 — trạng thái "AI đọc cả mùa" của truyện, nâng từ `SeasonReaderCard` lên chặng ⑤ để khung đọc có chữ lỗi theo tập
// mà không gọi thêm. Dời nguyên phần tải của card: reset khi đổi `storyId`, tải lại khi `refreshToken` đổi, poll 6s khi RUNNING.
import { useCallback, useEffect, useRef, useState } from 'react';
import { adaptationApi } from '../../../services/api/adaptation';
import type { SeasonReaderViewResponse } from '../../../types/adaptation';

export const SEASON_READER_POLL_MS = 6000;

export interface SeasonReaderApi {
  resp: SeasonReaderViewResponse | null;
  reload: () => Promise<void>;
}

/** `enabled=false` (chưa có kịch bản nào) ⇒ không gọi `season-reader` (giữ đúng P1). */
export const useSeasonReader = (storyId: string, refreshToken: number | string, enabled: boolean): SeasonReaderApi => {
  const [resp, setResp] = useState<SeasonReaderViewResponse | null>(null);
  const currentStoryIdRef = useRef(storyId);
  currentStoryIdRef.current = storyId;

  const reload = useCallback(async () => {
    const requested = storyId;
    try {
      const r = await adaptationApi.seasonReaderView(requested);
      if (currentStoryIdRef.current === requested) setResp(r); // bỏ kết quả về muộn khi đã đổi truyện
    } catch { /* khối phụ — lỗi mạng thì giữ trạng thái cũ */ }
  }, [storyId]);

  useEffect(() => { setResp(null); }, [storyId]);
  useEffect(() => { if (enabled) reload(); }, [enabled, reload, refreshToken]);

  const running = enabled && resp?.state === 'RUNNING';
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(reload, SEASON_READER_POLL_MS);
    return () => clearInterval(t);
  }, [running, reload]);

  return { resp, reload };
};
